import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, } from '@material-ui/core';
import IndexUtil from '../../../model/IndexUtil';

class MovieIndexOuzhi extends React.Component {



    render() {
        const { classes, data, matchType } = this.props;
        let datas = IndexUtil.handleIndex(data);
        return (
            <Grid container direction='column' alignItems='center' justifyContent='center' className={classes.root}>
                <Table style={{ width: '100%' }}>
                    <TableHead style={{ width: '100%' }}>
                        <TableRow style={{ width: '100%' }}>
                            <TableCell align='left' className={classes.tableHead} style={{ width: '30%', paddingLeft: 8 }}>赔率来源</TableCell>
                            <TableCell align='center' className={classes.tableHead} style={{ width: '12.5%' }}></TableCell>
                            <TableCell align='center' className={classes.tableHead} style={{ width: '12.5%' }}>胜</TableCell>
                            <TableCell align='center' className={classes.tableHead} style={{ width: '12.5%' }}>平</TableCell>
                            <TableCell align='center' className={classes.tableHead} style={{ width: '12.5%' }}>负</TableCell>
                            <TableCell align='right' className={classes.tableHead} style={{ width: '20%', paddingRight: 8 }}>返还率</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ width: '100%' }}>
                        {
                            datas.map((item, i) => (
                                <TableRow key={i} style={{ width: '100%' }}>
                                    <TableCell align='left' className={classes.tableBody} style={{ paddingLeft: 8 }}>
                                        <Typography style={{ fontSize: 11, color: '#0D0D0D' }}>{item.getName()}</Typography>
                                    </TableCell>
                                    <TableCell align='center' className={classes.tableBody}>
                                        <Typography style={{ fontSize: 11, color: '#878787' }}>初</Typography>
                                        <Typography style={{ fontSize: 11, color: '#878787' }}>即</Typography>
                                    </TableCell>
                                    <TableCell align='center' className={classes.tableBody}>
                                        <Typography style={{ fontSize: 11, color: '#0D0D0D' }}>{item.getInitEu(0)}</Typography>
                                        <Typography style={{ fontSize: 11, color: '#878787' }}>{item.getRealEu(0)}</Typography>
                                    </TableCell>
                                    <TableCell align='center' className={classes.tableBody}>
                                        <Typography style={{ fontSize: 11, color: '#0D0D0D' }}>{item.getInitEu(1)}</Typography>
                                        <Typography style={{ fontSize: 11, color: '#878787' }}>{item.getRealEu(1)}</Typography>
                                    </TableCell>
                                    <TableCell align='center' className={classes.tableBody}>
                                        <Typography style={{ fontSize: 11, color: '#0D0D0D' }}>{item.getInitEu(2)}</Typography>
                                        <Typography style={{ fontSize: 11, color: '#878787' }}>{item.getRealEu(2)}</Typography>
                                    </TableCell>
                                    <TableCell align='right' className={classes.tableBody} style={{ paddingRight: 8 }}>
                                        <Typography style={{ fontSize: 11, color: '#0D0D0D' }}>{item.getInitResult(matchType)}</Typography>
                                        <Typography style={{ fontSize: 11, color: '#878787' }}>{item.getRealResult(matchType)}</Typography>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: '#FFF'
    },
    tableHead: {
        fontSize: 7,
        color: '#898989',
        height: 36,
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 0, 0, 0),
        border: 0,
    },
    tableBody: {
        fontSize: 9,
        color: '#0D0D0D',
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(1, 0, 1, 0),
        border: 0,
        borderBottom: 'solid 1px #E2E2E2',
        height: 24,
    },

}))(MovieIndexOuzhi));